(function () {
  'use strict';

  function buildEmbedUrl(type, id) {
    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }
    return null;
  }

  function initVideoSection(root) {
    var trigger = root.querySelector('[data-video-trigger]');
    var embedWrap = root.querySelector('[data-video-embed]');
    if (!trigger || !embedWrap) return;

    var type = root.getAttribute('data-video-type');
    var id = root.getAttribute('data-video-id');

    trigger.addEventListener('click', function () {
      var src = buildEmbedUrl(type, id);
      if (!src) return;

      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', trigger.getAttribute('aria-label') || 'Video');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');

      embedWrap.appendChild(iframe);
      embedWrap.hidden = false;
      trigger.hidden = true;
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-video-section]').forEach(function (root) {
      if (root.videoSectionInit) return;
      root.videoSectionInit = true;
      initVideoSection(root);
    });
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();